export const validationRulesInfo = [
  {
    key: "datestart",
    title: "datestart",
    description: "Ensures the child date is on or after the parent date.",
  },
  {
    key: "dateend",
    title: "dateend",
    description: "Ensures the child date is on or before the parent date.",
  },
  {
    key: "smallernumber",
    title: "smallernumber",
    description: "Ensures the child number is greater than or equal to the parent number.",
  },
  {
    key: "largernumber",
    title: "largernumber",
    description: "Ensures the child number is less than or equal to the parent number.",
  },
  {
    key: "value_relationship",
    title: "value_relationship",
    description: "Ensures the child number is less than a calculated limit (e.g., parent value × 0.8).",
  },
  {
    key: "fixedvalues",
    title: "fixedvalues",
    description: "Ensures the child value is one of the allowed fixed values.",
  },
  {
    key: "max_limit",
    title: "max_limit",
    description: "Ensures the child number does not exceed the parent limit.",
  },
  {
    key: "dependency",
    title: "dependency",
    description: "Ensures both parent and child values are true (Boolean).",
  },
  {
    key: "lifecyclecheck",
    title: "lifecyclecheck",
    description: "Ensures the child lifecycle value comes in correct order after the parent and is not repeated if repetition is disallowed.",
  },
  {
    key: "exist_check",
    title: "exist_check",
    description: "Ensures the child value does not already exist as the parent value.",
  }
];

export const alertRulesInfo = [
  {
    key: "lower_limit",
    title: "Lower Limit",
    description: "Alert will be created if entered value less than or equal to lower limit value.",
  },
  {
    key: "upper_limit",
    title: "Upper Limit",
    description: "Alert will be created if entered value greater than or equal to upper limit value.",
  },
  {
    key: "equals",
    title: "Equals",
    description: "Alert will be created if entered value equal to set value.",
  },
  {
    key: "threshold_range",
    title: "Threshold Range",
    description: "Warning(yellow) alert will be created if entered value is between min and max value. If entered value exceeds max value danger(red) alert will be created.",
  },
  {
    key: "missing",
    title: "Missing",
    description: "Brown alert will be created if the value is missing.",
  },
];


export function formatCustomMessage(message: string, device: string): string[][] {
  if (!message || message.length === 0) return [];

  const rows = message.split("##");
  const result: string[][] = [];

  for (let row of rows) {
    const columns = row.split("**").map(col => col.trim()).filter(Boolean);
    result.push(columns);
  }

  return result;
}
